/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @interface ResultItemAPI
 * @hideconstructor
 * @classdesc API class that is used to work with a result data item.
 * @example queryResult.getResultItemList()[index]
 */
define([], () => {
	class ResultItemAPI {

		/**
		 * @function ResultItemAPI#getDataItemList
		 * @description Gets column information in the result data item.
		 * @public
		 *
		 * @return {DataItemAPI[]} Array of DataItemAPI {@link DataItemAPI}
		 */
		getDataItemList() {}

		/**
		 * @function ResultItemAPI#getId
		 * @description Gets the unique ID of the query result data item. It corresponds to the data item unique ID in the query spec.
		 * @private
		 *
		 * @return {String} Data item unique ID
		 */
		getId() {}

		/**
		 * @function ResultItemAPI#getRowCount
		 * @description Gets the row count of the corresponding column of the result data item.
		 * @public
		 *
		 * @return {Number} Number of rows in the corresponding column
		 */
		getRowCount() {}

		/**
		 * @function ResultItemAPI#getValue
		 * @description Gets the value object at the specified rowIndex.
		 * @public
		 *
		 * @param {Number} rowIndex  Index to access the items list.
		 * @return {ResultDataValue[]} Value of object array {@link ResultDataValue}
		 * @example
		 * [{
		 * 	value: 'dataset_csv.Product_line->[Camping Equipment]',
		 * 	label: 'Camping Equipment'
		 * }]
		 */
		getValue() {}

		/**
		 * @public
		 * @function ResultItemAPI#getDecorations
		 * @description Get decorations for the result item
		 * @return {Object} Object map containing decorations in name/value pairs. 
		 * Values are either a primitive value or an object representing the decoration.
		 * @example
		 *	{
		 *		"marker": 60.21043771043771,
		 *		"tooltip": "The average value of Audience Score % is 60.21.",
		 *		"markerCaption": "Average: 60.21"
		 *	}
		 */
		getDecorations() {}

		/**
		 * @public
		 * @function ResultItemAPI#clearDecorations
		 * @description Clear decorations for the result item
		 */
		clearDecorations() {}
	}

	return ResultItemAPI;
});
